import React from 'react'

import type { TagProps } from '@fourthwall/components'
import { Tag } from '@fourthwall/components'

import type { GiftCard } from '../../pages/GiftCards/GiftCards.types'
import { STATUSES } from './consts'

type GiftCardStatusTagProps = {
  status: GiftCard['status']
  size?: TagProps['size']
}

export const GiftCardStatusTag = ({ status, size }: GiftCardStatusTagProps) => (
  <Tag label={STATUSES[status]?.label} appearance={STATUSES[status]?.appearance} size={size} />
)
